import * as React from 'react';
import { useZustand } from 'use-zustand';
import { pathwayStore } from '../store';
import classnames from 'classnames';
import { IsCurrentStep } from '../helper';

function NavigationItem(props) {
  const {
    step,
    current
  } = props;

  const cssClasses = {
    root: 'page-quick-links__list-item',
    link: classnames({
      'page-quick-links__link link-level-1 with-sub-menu': true,
      'active': !!current,
    })
  };

  return (
    <li className={cssClasses.root}>
      <a className={cssClasses.link} href={`#step-${step.id}`}>
        {step.title}
      </a>
    </li>
  );
}

export default function Navigation(props) {
  const steps = useZustand(pathwayStore, (state) => { return state.steps }) || [];
  const currentStep = useZustand(pathwayStore, (state) => { return state.currentStep });
  const current = currentStep();

  if (steps.length === 0) { return null; }

  return (
    <div className='page-quick-links page-navigation nv-learning-pathway-navigation'>
      <ul>
        {steps.map(step => {
          return <NavigationItem key={step.id} step={step} current={IsCurrentStep(step, current)} />;
        })}
      </ul>
    </div>
  );
}
